import Login from 'i18n/es/Login';
import Offers from 'i18n/es/Offers';
import DatesUnits from 'i18n/es/DatesUnits';
import DownloadMobileApp from 'i18n/es/DownloadMobileApp';
import General from 'i18n/es/General.json';
import OfferDetail from 'i18n/es/OfferDetail';
import Jobs from 'i18n/es/Jobs';
import PendingJobDetail from 'i18n/es/PendingJobDetail';
import InTransitJobDetail from 'i18n/es/InTransitJobDetail';
import RecoverPassword from 'i18n/es/RecoverPassword';
import Chat from 'i18n/es/Chat';
import Banner from 'i18n/es/Banner';
import Pods from 'i18n/es/Pods';
import Alerts from 'i18n/es/Alerts';
import AccountSettings from 'i18n/es/AccountSettings';
import Documents from 'i18n/es/Documents';

const lang = {
  Login,
  Offers,
  DatesUnits,
  DownloadMobileApp,
  General,
  OfferDetail,
  Jobs,
  PendingJobDetail,
  InTransitJobDetail,
  RecoverPassword,
  Chat,
  Banner,
  Pods,
  Alerts,
  AccountSettings,
  Documents
};

export default lang;
